export type AdminOverviewResponse = {
  metrics: {
    totalOrders: number;
    paidOrders: number;
    pendingOrders: number;
    processingOrders: number;
    deliveredOrders: number;
    paidRevenue: number;
    totalUsers: number;
    activeProducts: number;
    lowStockProducts: number;
    stockUnits: number;
  };
  revenueSeries: Array<{
    monthKey: string;
    monthLabel: string;
    paidRevenue: number;
    paidOrders: number;
  }>;
  statusBreakdown: Array<{
    status: string;
    total: number;
  }>;
  recentOrders: Array<{
    id: number;
    addedOn: string | null;
    customerName: string;
    phone: string;
    total: number;
    amountPaid: number;
    status: string;
    paymentType: string;
    trackingNumber: string;
  }>;
  stockWatch: Array<{
    id: number;
    name: string;
    slug: string;
    quantity: number;
    price: number;
    category: string;
  }>;
  recentUsers: Array<{
    id: number;
    name: string;
    email: string;
    phone: string;
    role: "ADMIN" | "SALES" | "Customer";
    registeredOn: string | null;
  }>;
};

async function parseResponse(response: Response) {
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(data?.message || `Request failed: ${response.status}`);
  }

  return data;
}

export async function fetchAdminOverview() {
  const response = await fetch("/api/admin/overview", {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  return (await parseResponse(response)) as AdminOverviewResponse;
}
